import isObject from "lodash/isObject"
import Vue from "vue"

export class ConfigManager {
  store = new Vue({
    data: {
      store: {},
      watchers: {},
    },
    methods: {
      setConfig(obj, key, val, ns, override) {
        if (isObject(key)) {
          ns = val
          val = key
          Object.keys(val).forEach(k => {
            this.setConfig(obj, k, val[k], ns, override)
          })
          return
        }

        if (typeof key !== "string") {
          throw new Error("`Config key must be a string value.")
        }

        let k = ns ? `${ns}.${key}` : key
        if (!(k in obj) || override) {
          this.setConfigItem(obj, k, val)
        }
      },
      setConfigItem(obj, key, val) {
        Vue.set(obj, key, val)
      },
      set(key, val, ns) {
        this.setConfig(this.store, key, val, ns, true)
      },
      defaults(key, val, ns) {
        this.setConfig(this.store, key, val, ns, false)
      },
      get(key) {
        return this.store[key]
      },
    },
  })

  set(key, val, ns) {
    this.store.set(key, val, ns)
  }

  defaults(key, val, ns) {
    this.store.defaults(key, val, ns)
  }

  get(path) {
    return this.store.get(path)
  }
}

export default new ConfigManager()
